export const CircledQuestion = () => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.474 6.152C7.602 6.036 7.742 5.926 7.894 5.822C8.046 5.718 8.212 5.626 8.392 5.546C8.572 5.466 8.766 5.404 8.974 5.36C9.186 5.312 9.414 5.288 9.658 5.288C9.982 5.288 10.28 5.334 10.552 5.426C10.828 5.518 11.064 5.65 11.26 5.822C11.46 5.994 11.616 6.202 11.728 6.446C11.84 6.686 11.896 6.956 11.896 7.256C11.896 7.56 11.85 7.824 11.758 8.048C11.67 8.268 11.558 8.46 11.422 8.624C11.286 8.788 11.136 8.932 10.972 9.056C10.812 9.176 10.66 9.29 10.516 9.398C10.376 9.506 10.254 9.614 10.15 9.722C10.05 9.826 9.99 9.944 9.97 10.076L9.856 10.982H9.058L8.974 9.992C8.954 9.808 8.986 9.648 9.07 9.512C9.154 9.376 9.262 9.25 9.394 9.134C9.53 9.014 9.68 8.898 9.844 8.786C10.008 8.674 10.16 8.55 10.3 8.414C10.44 8.274 10.558 8.118 10.654 7.946C10.75 7.77 10.798 7.562 10.798 7.322C10.798 7.158 10.766 7.01 10.702 6.878C10.638 6.746 10.55 6.634 10.438 6.542C10.326 6.446 10.194 6.374 10.042 6.326C9.89 6.274 9.728 6.248 9.556 6.248C9.316 6.248 9.112 6.278 8.944 6.338C8.776 6.394 8.632 6.456 8.512 6.524C8.396 6.592 8.3 6.656 8.224 6.716C8.148 6.772 8.084 6.8 8.032 6.8C7.916 6.8 7.832 6.75 7.78 6.65L7.474 6.152ZM8.638 13.298C8.638 13.19 8.658 13.088 8.698 12.992C8.738 12.896 8.792 12.812 8.86 12.74C8.932 12.668 9.016 12.612 9.112 12.572C9.208 12.528 9.312 12.506 9.424 12.506C9.532 12.506 9.634 12.528 9.73 12.572C9.826 12.612 9.91 12.668 9.982 12.74C10.054 12.812 10.11 12.896 10.15 12.992C10.194 13.088 10.216 13.19 10.216 13.298C10.216 13.41 10.194 13.514 10.15 13.61C10.11 13.706 10.054 13.79 9.982 13.862C9.91 13.934 9.826 13.99 9.73 14.03C9.634 14.07 9.532 14.09 9.424 14.09C9.312 14.09 9.208 14.07 9.112 14.03C9.016 13.99 8.932 13.934 8.86 13.862C8.792 13.79 8.738 13.706 8.698 13.61C8.658 13.514 8.638 13.41 8.638 13.298Z"
        fill="white"
      />
      <path
        d="M9.5 0.5C14.4467 0.5 18.5 4.72882 18.5 10C18.5 15.2712 14.4467 19.5 9.5 19.5C4.55329 19.5 0.5 15.2712 0.5 10C0.5 4.72882 4.55329 0.5 9.5 0.5Z"
        stroke="white"
      />
    </svg>
  );
};

export const CheckboxSVG = ({ checked }) => {
  return (
    <svg
      className={checked ? 'text-light-green' : 'text-white'}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {checked && (
        <path
          d="M4.5 8L7.125 10.625L11.5 5.375"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
      <path
        d="M1.875 1C1.39175 1 1 1.39175 1 1.875V14.125C1 14.6082 1.39175 15 1.875 15H14.125C14.6082 15 15 14.6082 15 14.125V1.875C15 1.39175 14.6082 1 14.125 1H1.875Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
